import {Storage as Store} from '@capacitor/storage';
import store from "@/store";

export const CurrentUser = 'current_user';
export const SESSION_ID = 'sessionID';
export const AllUsers = 'all_users';
export const DEBTORS = 'debtors';
export const Ticket_Statuses = 'ticket_statuses';
export const ACCESS_TOKEN = 'access_token';
export const ACCESS_TOKEN_EXPIRES_AT = 'access_token_expires_at';

export const Storage = {
    setCurrentUser: async (payload) => {
        await Store.set({
            key: CurrentUser, value: JSON.stringify(payload)
        })
    },
    getCurrentUser: async () => {
        let value = store.getters.getCurrentUser;
        if (value) return value;

        value = await Store.get({
            key: CurrentUser
        })
        return JSON.parse(value.value);
    },

    setUsers: async (payload) => {
        await Store.set({
            key: AllUsers, value: JSON.stringify(payload)
        })
    },

    getAllUsers: async () => {
        const value = await Store.get({
            key: AllUsers
        })
        return JSON.parse(value.value);
    },

    setDebtors: async (payload) => {
        await Store.set({
            key: DEBTORS, value: JSON.stringify(payload)
        })
    },

    getAllDebtors: async () => {
        const value = await Store.get({
            key: DEBTORS
        })
        return JSON.parse(value.value);
    },

    setStatuses: async (payload) => {
        await Store.set({
            key: Ticket_Statuses, value: JSON.stringify(payload)
        })
    },

    getAllTicketStatuses: async () => {
        const value = await Store.get({
            key: Ticket_Statuses
        })
        return JSON.parse(value.value);
    },

    setTicketTypes: async (payload) => {
        await Store.set({
            key: Ticket_Types,
            value: JSON.stringify(payload)
        })
    },

    getAllTicketTypes: async () => {
        const value = await Store.get({
            key: Ticket_Types
        })
        return JSON.parse(value.value);
    },
    setSessionID: async (payload) => {
        await Store.set({
            key: SESSION_ID,
            value: JSON.stringify(payload)
        })
    },

    getSessionID: async () => {
        const value = await Store.get({ key: SESSION_ID })
        return JSON.parse(value.value);
    },
    setAccessToken: async (token, expiresAtEpochSecond) => {
        const normalized = String(token || '').trim();
        if (!normalized) {
            throw new Error('Access token is required');
        }
        await Store.set({ key: ACCESS_TOKEN, value: JSON.stringify(normalized) });
        if (expiresAtEpochSecond != null) {
            await Store.set({
                key: ACCESS_TOKEN_EXPIRES_AT,
                value: JSON.stringify(Number(expiresAtEpochSecond)),
            });
        }
    },
    getAccessToken: async () => {
        const raw = await Store.get({ key: ACCESS_TOKEN });
        if (!raw || raw.value == null) return null;
        try { return JSON.parse(raw.value); } catch { return null; }
    },
    getAccessTokenDetails: async () => {
        const token = await Storage.getAccessToken();
        let expiresAt = null;
        const raw = await Store.get({ key: ACCESS_TOKEN_EXPIRES_AT });
        if (raw && raw.value != null) {
            try { expiresAt = JSON.parse(raw.value); } catch { /* ignore */ }
        }
        const now = Math.floor(Date.now() / 1000);
        const expired = expiresAt != null && expiresAt <= now;
        return { token, expiresAt, expired };
    },
    clearAccessToken: async () => {
        try { await Store.remove({ key: ACCESS_TOKEN }); } catch { /* ignore */ }
        try { await Store.remove({ key: ACCESS_TOKEN_EXPIRES_AT }); } catch { /* ignore */ }
    },
}
